import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { AuthService } from '../../../auth';
import { AppearanceMenuComponent } from '../appearance-menu/appearance-menu.component';
import { CurrencySelectComponent } from '../currency-select/currency-select.component';
import { LanguageSelectComponent } from '../language-select/language-select.component';

/**
 * The per-user settings that are set once and rarely changed: language, currency and appearance.
 * They share one dropdown rather than three controls on the top bar.
 *
 * ⚠️ It sits OUTSIDE the collapsing navbar (see top-menu), because the bar is `navbar-expand-xxl` and
 * anything inside the collapse disappears behind the hamburger below 1400px.
 */
@Component({
  selector: 'app-preferences-menu',
  templateUrl: './preferences-menu.component.html',
  styleUrl: './preferences-menu.component.scss',
  imports: [
    AsyncPipe,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    AppearanceMenuComponent,
    CurrencySelectComponent,
    LanguageSelectComponent,
  ],
})
export class PreferencesMenuComponent implements OnInit {
  private readonly authService = inject(AuthService);

  /** Whether this app offers Light / Dark / Match Windows — see AppearanceMenuComponent. */
  public readonly showAppearance = input(false);
  /** Whether the user's menus have loaded; the currency list is only available once they have. */
  public readonly hasMenus = input(false);

  protected isAuthenticated$: Observable<boolean>;

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
  }
}
